var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "41px",
    viewBox: "0 0 41 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 10 Copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AFIX-secondary-mobile__mk2",
    transform: "translate(-27.000000, -2848.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-3-Copy",
    transform: "translate(0.000000, 2531.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(20.000000, 306.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy-3",
    transform: "translate(7.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 20.5,
    cy: 20.5,
    r: 20.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "email-icon--white",
    transform: "translate(9.000000, 11.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5359238,0 L2.46431086,0 C1.10893989,0 0,1.14324802 0,2.55961964 L0,3.72002929 L1.64287391,4.6330578 L11.1138073,9.89758596 C11.3602384,10.034138 11.6477413,10.034138 11.8941724,9.89758596 L21.3571261,4.56480128 L23,3.6348549 L23,2.5597659 C23,1.14339428 21.8993214,0.000146263979 20.5356891,0.000146263979 L20.5359238,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6746429,11.1800281 C12.305,11.3883556 11.9025469,11.4971743 11.5000939,11.4971743 C11.1058833,11.4971743 10.7032143,11.3883556 10.3335714,11.1800281 L1.64285714,6.04215548 L0,5.07249057 L0,16.2816037 C0,17.7767217 1.10892857,19 2.46428571,19 L20.5357143,19 C21.8993327,19 23,17.7767217 23,16.2816037 L23,5 L21.3571429,5.97851912 L12.6744082,11.1797174 L12.6746429,11.1800281 Z",
    id: "Path"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailWhite);
export default __webpack_public_path__ + "static/media/email--white.ccfe12a86a151f08fb4295b5ad301134.svg";
export { ForwardRef as ReactComponent };